import { API_BASE_URL } from "../config/config";
import axios from "axios";
import Cookies from "js-cookie";

const DomainMonitorToken = async (uid) => {
    //ask txshield to get the domain monitor token + dm_userid for the user
    let options = { headers: { Authorization: "Bearer " + Cookies.get("access_token") } };
    const data = await axios
        .get(API_BASE_URL + "/v3/domainmonitor/user/" + uid + "/token", options)
        .then(({ data }) => {
            return data;
        })
        .catch((error) => {
            console.error("Failed to fetch Domain Monitor token:", error.message);
            return false;
        });
    return data;
};
export default DomainMonitorToken;
